import React from "react";
import { useParams } from "react-router-dom";

// Example Blog Posts data
const posts = [
  {
    id: 1,
    title: "The Future of Trade in Sri Lanka",
    content: "Detailed content about the future of trade in Sri Lanka...",
    image: "https://via.placeholder.com/800x400",
    date: "July 20, 2024",
    category: "Trade",
    rating: 4,
  },
  {
    id: 2,
    title: "How to Scale Your Business Effectively",
    content: "Detailed content on how to scale a business effectively...",
    image: "https://via.placeholder.com/800x400",
    date: "July 15, 2024",
    category: "Business",
    rating: 5,
  },
  // More posts here...
];

const BlogDetailPage = () => {
  const { id } = useParams(); // Get the post ID from the URL
  const post = posts.find((p) => p.id === parseInt(id));

  if (!post) {
    return <div>Post not found!</div>;
  }

  return (
    <div style={{ padding: "20px", backgroundColor: "#f8f8f8" }}>
      <div style={{ backgroundColor: "#007bff", color: "white", padding: "60px 20px", textAlign: "center", borderRadius: "10px" }}>
        <h1>{post.title}</h1>
        <p>{post.date}</p>
      </div>

      <section style={{ marginTop: "40px", textAlign: "center" }}>
        <img
          src={post.image}
          alt={post.title}
          style={{ width: "100%", height: "auto", borderRadius: "10px", marginBottom: "30px" }}
        />
        <p style={{ fontSize: "18px", lineHeight: "1.8", color: "#555", maxWidth: "800px", margin: "0 auto" }}>
          {post.content}
        </p>
        <p style={{ fontSize: "16px", color: "#ffcc00" }}>Rating: {post.rating}⭐</p>
      </section>

      <section style={{ textAlign: "center", marginTop: "40px" }}>
        <h3>Leave a Comment</h3>
        <textarea
          placeholder="Write your comment here..."
          style={{
            width: "80%",
            height: "100px",
            padding: "10px",
            borderRadius: "10px",
            marginBottom: "20px",
            border: "1px solid #ddd",
          }}
        ></textarea>
        <br />
        <button style={{ padding: "10px 20px", backgroundColor: "#007bff", color: "white", borderRadius: "5px" }}>
          Submit Comment
        </button>
      </section>
    </div>
  );
};

export default BlogDetailPage;
